module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTIuNSIgc3Ryb2tlPSIjRkYwMDAwIi8+DQogIDxyZWN0IHg9IjUiIHk9IjYuNDE0MDYiIHdpZHRoPSIyIiBoZWlnaHQ9IjIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNSA2LjQxNDA2KSIgZmlsbD0iI0ZGMDAwMCIvPg0KICA8cmVjdCB4PSIxOS44NDkxIiB5PSI1IiB3aWR0aD0iMiIgaGVpZ2h0PSIyMSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTkuODQ5MSA1KSIgZmlsbD0iI0ZGMDAwMCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/warn.svg
// module id = kHD4
// module chunks = 1